import { Field, useFormikContext } from "formik";
import React, { useState } from "react";
import { MyFormValues } from "./leadManagement";
import { DropdownOption } from "../../types/dropDownTypes";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { handleSearch } from "../../utils/cancelPreviousRequests";
import { getUserDropdownListApi } from "../../store/saga/requests/tempRequests";
interface IOption {
  label: string;
  value: string | number;
}

export default function CampaignDetailForm() {
  const { values, setFieldValue } = useFormikContext<MyFormValues>();
  const [userOption, setUserOption] = useState<IOption[]>([]);

  const handleStatusChange = (name: string, option: DropdownOption) => {
    console.log(option);
    setFieldValue(name, option.value);
  };
  const datePickerChangeHandler = (date: any, name: string, formik: any) => {
    setFieldValue(name, new Date(date));
  };
  const loadUsersOptions = (searchValue: string, callback: any) => {
    // if (searchValue) {
    let abortController = handleSearch();
    setTimeout(() => {
      getUserDropdownListApi({
        name: searchValue,
      })
        .then(({ data }) => {
          const options = data?.data?.map(({ firstName, userId }: any) => ({
            label: firstName,
            value: userId,
          }));
          callback(options);
          setUserOption(options);
        })
        .catch((error: any) => console.log(error.message));
    }, 500);
    // }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="flex flex-col w-[35%] gap-1">
        <div className="flex flex-row gap-5 mb-5 items-center">
          <b> Campaign Type:</b>
          <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2">
            <Field
              className="transition-all ease-in-out"
              autoComplete="off"
              type="radio"
              name="type"
              id="NORMAL"
              value="NORMAL"
              onClick={() => {
                setFieldValue("assigneeId", null);
              }}
              checked={values.type === "NORMAL"}
            />
            <label htmlFor="NORMAL" className="crm-input-label">
              Normal
            </label>
          </div>
          <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2">
            <Field
              className="transition-all ease-in-out"
              autoComplete="off"
              type="radio"
              name="type"
              id="DEDICATED"
              value="DEDICATED"
              onClick={() => {
                setFieldValue("assigneeId", null);
              }}
              checked={values.type === "DEDICATED"}
            />
            <label htmlFor="DEDICATED" className="crm-input-label">
              Dedicated
            </label>
          </div>
        </div>
        <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
          {" "}
          <label htmlFor="DEDICATED" className="crm-input-label">
            Campaign Name
          </label>
          <Field
            className="rounded p-2 pl-3 "
            autoComplete="off"
            type="text"
            name="name"
            id="name"
          />
        </div>
        <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
          {" "}
          <label htmlFor="DEDICATED" className="crm-input-label">
            Assign Count
          </label>
          <Field
            className="rounded p-2 pl-3 "
            autoComplete="off"
            type="number"
            name="total"
            id="total"
          />
        </div>
        {values.type === "DEDICATED" && (
          <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
            {" "}
            <label htmlFor="DEDICATED" className="crm-input-label">
              Assign Agent
            </label>
            <AsyncSelect
              className=" bg-white  w-[50%]"
              cacheOptions
              loadOptions={loadUsersOptions}
              isSearchable
              noOptionsMessage={() => "No matching record found"}
              placeholder="Select Agent"
              name="assigneeId"
              defaultOptions
              onChange={(option: any) =>
                handleStatusChange("assigneeId", option)
              }
              // value={userOption.filter(
              //   (option) => option.value === values.assigneeId
              // )}
            />
          </div>
        )}

        <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
          {" "}
          <label htmlFor="DEDICATED" className="crm-input-label">
            Start Date
          </label>
          <DatePicker
            slotProps={{
              textField: {
                size: "small",
                error: false,
              },
            }}
            className=" bg-white w-[50%]"
            format="DD/MM/YYYY"
            onChange={(e) => datePickerChangeHandler(e, "startDate", values)}
            value={moment(values.startDate)}
          />
        </div>
        <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
          {" "}
          <label htmlFor="DEDICATED" className="crm-input-label">
            End Date
          </label>
          <DatePicker
            slotProps={{
              textField: {
                size: "small",
                error: false,
              },
            }}
            className=" bg-white  w-[50%]"
            format="DD/MM/YYYY"
            onChange={(e) => datePickerChangeHandler(e, "endDate", values)}
            value={moment(values.endDate)}
          />
        </div>
        <div className="col-span-3 mt-1 flex gap-2 lg:col-span-2 items-center justify-between">
          {" "}
          <label htmlFor="DEDICATED" className="crm-input-label">
            Remarks
          </label>
          <Field
            className="rounded p-2 pl-3 "
            autoComplete="off"
            type="text"
            name="remarks"
            id="remark"
          />
        </div>
      </div>
    </LocalizationProvider>
  );
}
